module.exports = __webpack_public_path__ + "img/product2.f54ea19f.jpg";